module.exports = __webpack_public_path__ + "img/email_send.4cdd8cdc.png";